/** Meta Pixel 事件上报（fail-safe 不影响业务流程） */

var META_PIXEL_ID = "1497987042165209";
var loadStarted = false;

/** Meta Pixel 官方 base code（改写为函数式动态加载，队列机制保证脚本加载完成前入队的事件不丢） */
const loadMetaPixel = () => {
  if (loadStarted) return;
  loadStarted = true;
  // eslint-disable-next-line
  !(function (f, b, e, v) {
    if (f.fbq) return;
    var n = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    var t = b.createElement(e);
    t.async = !0;
    t.src = v;
    var s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
};

/** 应用启动时初始化（非 TikTok 渠道调用），幂等 */
export function initMetaPixel() {
  try {
    console.log("[MetaPixel] init");
    loadMetaPixel();
  } catch (e) {}
}

/** 上报标准事件（fail-safe：任何异常吞掉，不影响业务流程；首次上报自动加载基础代码） */
export function trackMetaEvent(eventName, params) {
  try {
    // vconsole 调试日志：打印事件名与参数
    console.log("[MetaPixel] track:", eventName, params || {});
    loadMetaPixel();
    if (window.fbq) {
      window.fbq("track", eventName, params || {}, {
        eventID: params && params.event_id ? String(params.event_id) : undefined,
      });
    } else {
      console.log("[MetaPixel] window.fbq 不存在，事件未发送（基础像素代码未加载）");
    }
  } catch (e) {}
}

/** Lead：匿名注册成功（event_id 为用户 id，取不到时不带该字段；
 * 是否上报/去重由 pixelReport 按渠道控制，这里只负责发送） */
export function reportLead(userId) {
  const params = {};
  if (userId) {
    params.event_id = String(userId);
  }
  trackMetaEvent("Lead", params);
}

/** Purchase：value 必填，币种固定 USD；event_id 为订单 id（取不到时不带该字段） */
export function reportPurchase(value, orderId) {
  const params = {
    currency: "USD",
    value: Number(value) || 0,
  };
  if (orderId) {
    params.event_id = String(orderId);
  }
  trackMetaEvent("Purchase", params);
}

/** Subscribe：VIP 订阅成功（order_type === 2）；event_id 为订单 id（取不到时不带该字段） */
export function reportSubscribe(value, orderId) {
  const params = {
    currency: "USD",
    value: Number(value) || 0,
  };
  if (orderId) {
    params.event_id = String(orderId);
  }
  trackMetaEvent("Subscribe", params);
}
